(function () {
	var FORM_SELECTOR = "form.contact-escribenos__form-wrapper";
	var FAIL_MS = 15000;
	var SUCCESS_FALLBACK_MS = 1200;
	var MIN_LOADING_MS = 2200;

	var bindContactForms = function () {
		document.querySelectorAll(FORM_SELECTOR).forEach(bindContactForm);
	};

	var bindContactForm = function (formEl) {
		if (formEl.dataset.escribenosBound === "true") {
			return;
		}

		formEl.dataset.escribenosBound = "true";
		formEl.setAttribute("data-shopify-captcha", "true");
		attachContactIframe(formEl);

		var existingSuccess = formEl.querySelector("[data-escribenos-panel-success]");
		if (existingSuccess && !existingSuccess.hidden) {
			formEl.dataset.escribenosSuccess = "true";
			formEl.classList.add("is-contact-success");
		}

		// Shopify captcha replaces form.submit after wiring. Assign a native
		// iframe submit first so captcha captures it and calls it with a token.
		try {
			formEl.submit = function () {
				postContactFormNative(formEl);
			};
		} catch (err) {}

		protectContactForm(formEl);

		formEl.addEventListener(
			"submit",
			function (e) {
				e.preventDefault();
				e.stopImmediatePropagation();

				if (formEl.dataset.escribenosLoading === "true") {
					return;
				}

				if (formEl.dataset.escribenosSuccess === "true") {
					return;
				}

				if (typeof formEl.reportValidity === "function" && !formEl.reportValidity()) {
					return;
				}

				markContactSubmitting(formEl);
				runContactCaptchaSubmit(formEl);
			},
			true
		);

		var resetEl = formEl.querySelector("[data-escribenos-reset]");
		if (resetEl) {
			resetEl.addEventListener("click", function (e) {
				e.preventDefault();
				resetContactForm(formEl);
			});
		}
	};

	var attachContactIframe = function (formEl) {
		var name = (formEl.id || "ContactEscribenosForm") + "-frame";
		var iframe = document.getElementById(name);

		if (!iframe) {
			iframe = document.createElement("iframe");
			iframe.name = name;
			iframe.id = name;
			iframe.title = "Contact";
			iframe.setAttribute("aria-hidden", "true");
			iframe.tabIndex = -1;
			iframe.style.cssText =
				"position:absolute;width:0;height:0;border:0;overflow:hidden;visibility:hidden";
			formEl.parentNode.insertBefore(iframe, formEl.nextSibling);

			iframe.addEventListener("load", function () {
				if (formEl.dataset.escribenosExpecting !== "true") {
					return;
				}

				formEl.dataset.escribenosExpecting = "";

				try {
					var href = iframe.contentWindow.location.href || "";
					if (href.indexOf("/challenge") !== -1) {
						failContactForm(formEl);
						return;
					}
				} catch (err) {
					// X-Frame-Options may block reading the response; the POST still ran.
				}

				showContactSuccess(formEl);
			});
		}

		formEl.setAttribute("target", name);
	};

	var protectContactForm = function (formEl, callback) {
		if (formEl.getAttribute("data-hcaptcha-bound") === "true") {
			if (typeof callback === "function") {
				callback();
			}
			return;
		}

		if (formEl.dataset.cptcha === "true" && typeof callback === "function") {
			var started = Date.now();
			var wait = function () {
				if (formEl.getAttribute("data-hcaptcha-bound") === "true") {
					callback();
					return;
				}

				if (Date.now() - started > 8000) {
					failContactForm(formEl);
					return;
				}

				setTimeout(wait, 50);
			};
			wait();
			return;
		}

		var captcha = window.Shopify && window.Shopify.captcha;
		if (captcha && typeof captcha.protect === "function") {
			try {
				captcha.protect(formEl, callback);
				return;
			} catch (err) {}
		}

		if (typeof callback === "function") {
			callback();
		}
	};

	var runContactCaptchaSubmit = function (formEl) {
		var submitWithCaptcha = function () {
			try {
				formEl.submit();
			} catch (err) {
				failContactForm(formEl);
				return;
			}

			if (formEl.dataset.escribenosExpecting !== "true") {
				return;
			}

			// X-Frame-Options can block the iframe response/load event. If the POST
			// already went out, show success shortly after without moving the page.
			if (formEl._escribenosSuccessTimer) {
				clearTimeout(formEl._escribenosSuccessTimer);
			}
			formEl._escribenosSuccessTimer = setTimeout(function () {
				if (formEl.dataset.escribenosExpecting === "true") {
					formEl.dataset.escribenosExpecting = "";
					showContactSuccess(formEl);
				}
			}, SUCCESS_FALLBACK_MS);
		};

		protectContactForm(formEl, submitWithCaptcha);
	};

	var getContactErrorMessage = function (formEl) {
		var errorEl = formEl.querySelector("[data-escribenos-errors]");
		return (
			formEl.getAttribute("data-error-message") ||
			(errorEl && errorEl.getAttribute("data-error-message")) ||
			"No pudimos enviar tu mensaje. Inténtalo de nuevo."
		);
	};

	var markContactSubmitting = function (formEl) {
		var errorEl = formEl.querySelector("[data-escribenos-errors]");
		var submitEl = formEl.querySelector("[data-escribenos-submit]");

		formEl.dataset.escribenosExpecting = "true";
		formEl.dataset.escribenosLoading = "true";
		formEl._escribenosStartedAt = Date.now();

		if (errorEl) {
			errorEl.setAttribute("hidden", "");
			errorEl.textContent = "";
		}

		if (submitEl) {
			submitEl.classList.add("loading");
			submitEl.setAttribute("aria-busy", "true");
			setTimeout(function () {
				submitEl.disabled = true;
			}, 0);
		}

		if (formEl._escribenosFailTimer) {
			clearTimeout(formEl._escribenosFailTimer);
		}

		formEl._escribenosFailTimer = setTimeout(function () {
			if (formEl.dataset.escribenosLoading === "true") {
				failContactForm(formEl);
			}
		}, FAIL_MS);
	};

	var clearContactTimers = function (formEl) {
		if (formEl._escribenosFailTimer) {
			clearTimeout(formEl._escribenosFailTimer);
			formEl._escribenosFailTimer = null;
		}
		if (formEl._escribenosSuccessTimer) {
			clearTimeout(formEl._escribenosSuccessTimer);
			formEl._escribenosSuccessTimer = null;
		}
		if (formEl._escribenosRevealTimer) {
			clearTimeout(formEl._escribenosRevealTimer);
			formEl._escribenosRevealTimer = null;
		}
	};

	var failContactForm = function (formEl) {
		var errorEl = formEl.querySelector("[data-escribenos-errors]");
		var submitEl = formEl.querySelector("[data-escribenos-submit]");

		formEl.dataset.escribenosExpecting = "";
		formEl.dataset.escribenosLoading = "false";
		clearContactTimers(formEl);

		if (submitEl) {
			submitEl.classList.remove("loading");
			submitEl.disabled = false;
			submitEl.removeAttribute("aria-busy");
		}

		if (errorEl) {
			errorEl.removeAttribute("hidden");
			errorEl.textContent = getContactErrorMessage(formEl);
		}
	};

	var showContactSuccess = function (formEl) {
		if (formEl.dataset.escribenosSuccess === "true") {
			return;
		}

		var started = formEl._escribenosStartedAt || Date.now();
		var remaining = MIN_LOADING_MS - (Date.now() - started);

		if (remaining > 50) {
			if (formEl._escribenosRevealTimer) {
				clearTimeout(formEl._escribenosRevealTimer);
			}
			formEl._escribenosRevealTimer = setTimeout(function () {
				revealContactSuccess(formEl);
			}, remaining);
			return;
		}

		revealContactSuccess(formEl);
	};

	var revealContactSuccess = function (formEl) {
		if (formEl.dataset.escribenosSuccess === "true") {
			return;
		}

		formEl.dataset.escribenosSuccess = "true";
		formEl.dataset.escribenosExpecting = "";
		formEl.dataset.escribenosLoading = "false";
		clearContactTimers(formEl);

		var fieldsEl = formEl.querySelector("[data-escribenos-form-stack]");
		var successEl = formEl.querySelector("[data-escribenos-panel-success]");
		var errorEl = formEl.querySelector("[data-escribenos-errors]");
		var submitEl = formEl.querySelector("[data-escribenos-submit]");

		if (errorEl) {
			errorEl.setAttribute("hidden", "");
			errorEl.textContent = "";
		}

		if (submitEl) {
			submitEl.classList.remove("loading");
			submitEl.disabled = true;
			submitEl.removeAttribute("aria-busy");
		}

		formEl.classList.add("is-contact-success");

		if (fieldsEl) {
			fieldsEl.hidden = true;
			fieldsEl.setAttribute("hidden", "");
		}

		if (successEl) {
			successEl.hidden = false;
			successEl.removeAttribute("hidden");
			if (typeof successEl.focus === "function") {
				try {
					successEl.focus({ preventScroll: true });
				} catch (err) {
					successEl.focus();
				}
			}
		}
	};

	var resetContactForm = function (formEl) {
		clearContactTimers(formEl);

		formEl.dataset.escribenosSuccess = "";
		formEl.dataset.escribenosExpecting = "";
		formEl.dataset.escribenosLoading = "false";
		formEl.classList.remove("is-contact-success");

		var fieldsEl = formEl.querySelector("[data-escribenos-form-stack]");
		var successEl = formEl.querySelector("[data-escribenos-panel-success]");
		var errorEl = formEl.querySelector("[data-escribenos-errors]");
		var submitEl = formEl.querySelector("[data-escribenos-submit]");

		if (typeof formEl.reset === "function") {
			formEl.reset();
		}

		if (errorEl) {
			errorEl.setAttribute("hidden", "");
			errorEl.textContent = "";
		}

		if (submitEl) {
			submitEl.classList.remove("loading");
			submitEl.disabled = false;
			submitEl.removeAttribute("aria-busy");
		}

		if (successEl) {
			successEl.hidden = true;
			successEl.setAttribute("hidden", "");
		}

		if (fieldsEl) {
			fieldsEl.hidden = false;
			fieldsEl.removeAttribute("hidden");
		}
	};

	var postContactFormNative = function (formEl) {
		var tokenField = formEl.querySelector('[name="h-captcha-response"]');
		if (tokenField && !tokenField.value) {
			failContactForm(formEl);
			return;
		}

		attachContactIframe(formEl);
		formEl.dataset.escribenosExpecting = "true";
		HTMLFormElement.prototype.submit.call(formEl);
	};

	var applySuccessFromUrl = function () {
		try {
			var search = window.location.search || "";
			if (!/(^|[?&])contact_posted=true(?:&|$)/.test(search)) {
				return;
			}

			document.querySelectorAll(FORM_SELECTOR).forEach(function (formEl) {
				revealContactSuccess(formEl);
			});

			var u = new URL(window.location.href);
			u.searchParams.delete("contact_posted");
			var q = u.searchParams.toString();
			var next = u.pathname + (q ? "?" + q : "");
			window.history.replaceState({}, "", next);
		} catch (e) {}
	};

	var init = function () {
		bindContactForms();
		applySuccessFromUrl();
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}

	document.addEventListener("shopify:section:load", bindContactForms);
})();
